module.exports = __webpack_public_path__ + "img/SLT_0740-Bearbeitet.041a4e90.jpg";